import React from 'react'
// import { contactImg } from "../../assets/index";
import { FaFacebookF, FaLinkedinIn, FaGithub, FaInstagram } from "react-icons/fa";
import { SiUpwork } from "react-icons/si";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      {/* <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      /> */}
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Fourat ABDELLATIF</h3>
        <p className="text-lg font-normal text-gray-400">
          Software Engineer
        </p>
        <p className="text-base text-gray-400 tracking-wide">
        Got a project or question? Reach out, I’d love to connect!
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <a href="tel:+21626699906" className="text-lightText">+216 26699906</a>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email: <a href="mailto:fourat.abdeltif@gmail.com" className="text-lightText">fourat.abdeltif@gmail.com</a>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        {/* <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2> */}
          <div className="flex gap-2">
            <a href='https://www.linkedin.com/in/fourat-abdellatif' target='_blank' rel="noreferrer" className="bannerIcon">
              <FaLinkedinIn />
            </a>
            <a href='https://www.facebook.com/fourat.abdellatif.3' target='_blank' rel="noreferrer" className="bannerIcon">
              <FaFacebookF />
            </a>
            <a href='https://www.instagram.com/fourat.abdeltif' target='_blank' rel="noreferrer" className="bannerIcon">
              <FaInstagram />
            </a>
            <a href='https://github.com/fouratabdellatif' target='_blank' rel="noreferrer" className="bannerIcon">
              <FaGithub />
            </a>
            <a href='https://www.upwork.com/freelancers/~01a64f5a81d6d1dc57' target='_blank' rel="noreferrer" className="bannerIcon">
              <SiUpwork />
            </a>
          </div>
      </div>
    </div>
  );
}

export default ContactLeft